(function () {
  'use strict';

  document.querySelectorAll('.idp-system-card[data-system-code]').forEach(function (card) {
    var footer = card.querySelector('footer');
    if (!footer || footer.querySelector('[data-idp-system-calculate]')) return;
    var link = document.createElement('a');
    link.href = '/pages/calculadora-de-consumos?system=' + encodeURIComponent(card.dataset.systemCode) + '#calculadora-consumos';
    link.dataset.idpSystemCalculate = '';
    link.textContent = 'Calcular sistema';
    footer.insertBefore(link, footer.lastElementChild);
  });
})();
